var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3123_1920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.599976C3.63437 0.599976 0.5 3.73435 0.5 7.59998C0.5 11.4656 3.63437 14.6 7.5 14.6C11.3656 14.6 14.5 11.4656 14.5 7.59998C14.5 3.73435 11.3656 0.599976 7.5 0.599976ZM7.5 13.4125C4.29063 13.4125 1.6875 10.8094 1.6875 7.59998C1.6875 4.3906 4.29063 1.78748 7.5 1.78748C10.7094 1.78748 13.3125 4.3906 13.3125 7.59998C13.3125 10.8094 10.7094 13.4125 7.5 13.4125Z",
    fill: "black",
    fillOpacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74976 4.84998C6.74976 5.04889 6.82877 5.23965 6.96943 5.38031C7.11008 5.52096 7.30084 5.59998 7.49976 5.59998C7.69867 5.59998 7.88943 5.52096 8.03009 5.38031C8.17074 5.23965 8.24976 5.04889 8.24976 4.84998C8.24976 4.65106 8.17074 4.4603 8.03009 4.31965C7.88943 4.17899 7.69867 4.09998 7.49976 4.09998C7.30084 4.09998 7.11008 4.17899 6.96943 4.31965C6.82877 4.4603 6.74976 4.65106 6.74976 4.84998ZM7.87476 6.59998H7.12476C7.05601 6.59998 6.99976 6.65623 6.99976 6.72498V10.975C6.99976 11.0437 7.05601 11.1 7.12476 11.1H7.87476C7.94351 11.1 7.99976 11.0437 7.99976 10.975V6.72498C7.99976 6.65623 7.94351 6.59998 7.87476 6.59998Z",
    fill: "black",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3123_1920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.5 0.599976)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/info-gray.7afd69aca700556fb78fba61b4b87b9f.svg";
export { ForwardRef as ReactComponent };